import React from 'react';
import { Field, useFormikContext } from 'formik';
import Box from '@mui/material/Box';

import { FormErrorUI, FormLabelUI, InputUI } from '../../Interface';
import { InputAdornment } from '@mui/material';

const ProductionQuantities = ({ autocompleteData }) => {
  const { values, errors } = useFormikContext();
  const getItemQtyUnitCode = (itemCode, fallbackQtyUnitId = null) => {
    if (!autocompleteData) return '';

    let quantityUnitId = fallbackQtyUnitId;

    if (!quantityUnitId && itemCode) {
      const itemRow = values?.productionItem?.find((pi) => pi.itemCode === itemCode);
      quantityUnitId = itemRow?.quantityUnitId ?? null;
    }

    if (!quantityUnitId) return '';

    const quantityUnit = autocompleteData?.quantityUnit.find((i) => i.id === quantityUnitId);

    return quantityUnit?.code || '';
  };

  const getFirstSecondaryProduct = () => {
    const secondaryProductRow = values?.productionItem?.find((pi) => pi.secondaryProduct);
    return secondaryProductRow ?? null;
  };

  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2 ">
      <div className="col-span-1 ">
        <Field
          type="text"
          name="completedQuantity"
          disabled
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Kész" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.completedQuantity} />}
          InputLabelProps={{ shrink: values.completedQuantity !== '' || values.completedQuantity !== null }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{getItemQtyUnitCode(values.articleNumber, values.me)}</InputAdornment>
            ),
          }}
        />
      </div>

      <div className="col-span-1">
        <Field
          type="text"
          name="secondayProductQuantity"
          disabled
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Selejt" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.secondayProductQuantity} />}
          InputLabelProps={{ shrink: values.secondayProductQuantity !== '' || values.secondayProductQuantity !== null }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {getItemQtyUnitCode(getFirstSecondaryProduct()?.itemCode, getFirstSecondaryProduct()?.quantityUnitId)}
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default ProductionQuantities;
